import ClearingAPI from '@shared/api';

export const {
    eDocs: { generate: generateEDoc },
} = ClearingAPI.settings;
